import { createSelector } from '@reduxjs/toolkit';
const reduxTakeValidationMediasReducer = (state) => state.reduxTakeValidationMedias;
export const reduxTakeValidationMediasDataSelector = createSelector(reduxTakeValidationMediasReducer, (reducer) => reducer.data);
